// init base functions
$(window).on('load', function () {
    classOnBody($('main').attr('id'));
    scrollDirection();
    initGettersAndSetters();
    changeTouchClickText();
});
$(window).on('hashchange', function () {
    initGettersAndSetters();
});

if ($('#btnPopUp').length) {
    $('#btnPopUp').trigger('click');
}

// init AOS
if (is.not.ie()) {
    AOS.init();
} else {
    $('*').removeAttr("data-aos");
}

// nav
if ($('.l-nav').length) {
    var propsNav = {
        active: 'is-active',
        body: $('body'),
        nav: $('.l-nav'),
        hamburguer: $('.l-nav .c-hamburguer'),
        contentHero: $('.l-nav__contentHero'),
        mask: $('.l-nav__maskMenu'),
        maskAll: $('.l-nav__maskMenu.maskAll'),
    };

    function checkResponsiveMode() {
        var resultCheck;
        var displayCheck = propsNav.hamburguer.css('display');
        if (displayCheck !== 'none') {
            resultCheck = 'is-responsive';
            propsNav.nav.removeClass('is-desktop');
            propsNav.nav.addClass('is-responsive');
        } else {
            resultCheck = 'is-desktop';
            propsNav.nav.removeClass('is-responsive');
            propsNav.nav.addClass('is-desktop');
        }
        return resultCheck;
    }

    function closeAllSubMenus() {
        $('.c-subMenu').removeClass('is-active');
    }

    function closeResponsiveMenu() {
        propsNav.hamburguer.removeClass(propsNav.active);
        propsNav.contentHero.removeClass(propsNav.active);
    }

    function hideMaskMenu() {
        propsNav.mask.removeClass(propsNav.active);
    }

    function disableOverflow() {
        propsNav.body.addClass('u-overflowBlocked');
    }

    function enableOverflow() {
        propsNav.body.removeClass('u-overflowBlocked');
    }


    // RESPONSIVE MENU
    // - open / close
    propsNav.hamburguer.on('click', function () {
        if ($(this).hasClass(propsNav.active)) {
            // close menu
            enableOverflow();
            $(this).removeClass(propsNav.active);
            propsNav.maskAll.removeClass(propsNav.active);
            propsNav.contentHero.removeClass(propsNav.active);
        } else {
            // open menu
            disableOverflow();
            $(this).addClass(propsNav.active);
            propsNav.maskAll.addClass(propsNav.active);
            propsNav.contentHero.addClass(propsNav.active);
        }
    });
    // - close
    propsNav.maskAll.on('click', function () {
        closeResponsiveMenu();
        hideMaskMenu();
        closeAllSubMenus();
        enableOverflow();
    });


    // RESPONSIVE MODE
    $(window).on('resize', function () {
        if (checkResponsiveMode() === "is-desktop") {
            if (propsNav.contentHero.hasClass(propsNav.active)) {
                closeAllSubMenus();
                closeResponsiveMenu();
                hideMaskMenu();
            }
        }
    });

}

// modules
if ($('.m_whatsApp').length) {
    var wpp__parts = {
        link_mobile: 'http://api.whatsapp.com/',
        link_web: 'https://web.whatsapp.com/',
        phone: 'send?phone=',
        msg: 'text='
    };
    $('.js-openWhatsModule').on('click', function () {
        var wppNumber = $(this).parent('.m_whatsApp').attr("data-whatsNumber");
        openWhatsApp(wppNumber);
    });

    function openWhatsApp(number) {
        console.log(number)
        if (is.iphone() || is.androidPhone() || is.windowsPhone() || is.blackberry() || is.mobile()) {
            window.open(wpp__parts.link_mobile + wpp__parts.phone + number, '_blank');
        } else {
            window.open(wpp__parts.link_web + wpp__parts.phone + number, '_blank');
        }
    }
}
if ($('#w_ieDetect').length) {
    function showMessageOnIE(warnLevel) {
        // warnLevel = 1 -> Remover aviso
        // warnLevel = 2 -> Recolher aviso
        // warnLevel = 3 -> Bloquear navegação

        var ieDetectEl = $('#w_ieDetect');
        var ieDetectEl__mask = $('#w_ieDetect__mask');
        var ieDetectEl__unlock = $('.w_ieDetect__unlockSite');

        if (is.ie()) {
            if (warnLevel === 1) {
                $('body').css('overflow', 'hidden');
                ieDetectEl.removeClass('u-dnone').addClass('is-visible');
                ieDetectEl__mask.removeClass('u-dnone').addClass('is-visible');
                ieDetectEl__unlock.on('click', function () {
                    ieDetectEl.remove();
                    ieDetectEl__mask.remove();
                    $('body').css('overflow-y', 'auto');
                    $('body').css('overflow-x', 'hidden');
                });
            }
            if (warnLevel === 2) {
                //block overflow and show modal
                $('body').css('overflow', 'hidden');
                ieDetectEl.removeClass('u-dnone').addClass('is-visible');
                ieDetectEl__mask.removeClass('u-dnone').addClass('is-visible');

                // hide modal and mask
                ieDetectEl__unlock.on('click', function () {
                    $(this).remove();
                    ieDetectEl__mask.remove();
                    ieDetectEl.removeClass('is-visible');
                    ieDetectEl.addClass('is-fixed');
                    $('body').css('overflow-y', 'auto');
                    $('body').css('overflow-x', 'hidden');
                });
            }
            if (warnLevel === 3) {
                $('nav').remove();
                $('header').remove();
                $('footer').remove();
                $('main').remove();
                ieDetectEl__unlock.remove();
                $('body').css('overflow', 'hidden');
                ieDetectEl.removeClass('u-dnone').addClass('is-visible');
                ieDetectEl__mask.removeClass('u-dnone').addClass('is-visible');
            }
        } else {
            ieDetectEl.remove();
            ieDetectEl__mask.remove();
        }
    }

    $(window).on('load', showMessageOnIE(3));
}
if ($('.auxElements__grid').length) {
    $('.auxElements__controls .toggleGrid').on('click', function () {
        $('.auxElements__controls .toggleGrid').toggleClass('is-active');
        $('.auxElements__grid').toggleClass('u-dnone').toggleClass('is-active');
        $('.auxElements__grid .line').toggleClass('is-active');
    });
}
if ($('.auxElements__controls').length) {
    function identifyScroll() {
        returnScroll = 1;
        if ($('body').hasClass('scrolledDown')) {
            returnScroll = 'Down';
        } else if ($('body').hasClass('scrolledUp')) {
            returnScroll = 'Up';
        } else {
            returnScroll = 'Static';
        }
        return returnScroll;
    }

    function tasksAuxVars() {
        $('.auxElements__controls .scrollEfetuado').html(Math.round($(window).scrollTop()));
        $('.auxElements__controls .scrollDirection').html(identifyScroll());
        $('.auxElements__controls .viewportWidth').html(Math.round($(window).width()));
        $('.auxElements__controls .viewportHeight').html(Math.round($(window).height()));
        $('.auxElements__controls .navHeight').html(Math.round(get__navHeight()));
    }

    $(document).on('ready', function () {
        tasksAuxVars();
    });
    $(window).on('load', function () {
        tasksAuxVars();
    });
    $(window).on('resize', function () {
        tasksAuxVars();
    });
    $(window).on('scroll', function () {
        tasksAuxVars();
    });
}


// fecha resultado horário em tempo real
$('.fecharTempoReal').on('click', function (e) {
    e.preventDefault();
    $('.tempoRealResult').addClass('d-none');

});

// institucional
$('.buttonSideBar').on('click', function (e) {
    e.preventDefault();
    $('.buttonSideBar').removeClass('is-active');
    $(this).addClass('is-active');
    var tipo = $(this).attr('data-tipo');
    if (tipo == 'historia') {
        $('#historia').removeClass('d-none');
        $('#qualidade').addClass('d-none');
        $('#frota').addClass('d-none');
    } else if (tipo == 'qualidade') {
        $('#qualidade').removeClass('d-none');
        $('#historia').addClass('d-none');
        $('#frota').addClass('d-none');
    } else if (tipo == 'frota') {
        $('#frota').removeClass('d-none');
        $('#historia').addClass('d-none');
        $('#qualidade').addClass('d-none');
    }
});


// contato
$('.buttonSideBarContato').on('click', function (e) {
    e.preventDefault();
    $('.buttonSideBarContato').removeClass('is-active');
    $(this).addClass('is-active');
    var tipo = $(this).attr('data-tipo');
    if (tipo == 'contatos') {
        $('#contatos').removeClass('d-none');
        $('#linksUteis').addClass('d-none');
    } else if (tipo == 'linksUteis') {
        $('#linksUteis').removeClass('d-none');
        $('#contatos').addClass('d-none');
    }
});

// cartoes
var swiper = new Swiper(".swiperCard", {
    effect: "coverflow",
    grabCursor: true,
    centeredSlides: true,
    slidesPerView: "auto",
    coverflowEffect: {
        rotate: 30,
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: true,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

// muda slide e muda o conteúdo
swiper.on('slideChange', function () {
    console.log(swiper.activeIndex); //numero de cada card
    var tipo = swiper.activeIndex;
    if (tipo == '0') {
        $('#f-valeTransporte').removeClass('d-none');
        $('#f-estudante').addClass('d-none');
    } else if (tipo == '1') {
        $('#f-estudante').removeClass('d-none');
        $('#f-valeTransporte').addClass('d-none');
    } else if (tipo == '2') {
        $('#f-idoso').removeClass('d-none');
        $('#f-valeTransporte').addClass('d-none');
        $('#f-estudante').addClass('d-none');
    } else if (tipo == '3') {
        $('#f-especial').removeClass('d-none');
        $('#f-valeTransporte').addClass('d-none');
        $('#f-estudante').addClass('d-none');
        $('#f-idoso').addClass('d-none');
    } else if (tipo == '4') {
        $('#f-cidadao').removeClass('d-none');
        $('#f-valeTransporte').addClass('d-none');
        $('#f-estudante').addClass('d-none');
        $('#f-idoso').addClass('d-none');
        $('#f-especial').addClass('d-none');
    } else if (tipo == '5') {
        $('#f-professor').removeClass('d-none');
        $('#f-valeTransporte').addClass('d-none');
        $('#f-estudante').addClass('d-none');
        $('#f-idoso').addClass('d-none');
        $('#f-especial').addClass('d-none');
        $('#f-cidadao').addClass('d-none');

    }
});

// faq cartoes
$('.c-tab__head').on('click', function () {
    $(this).parent().toggleClass('is-active');
});

// abre o modal
$(document).on('click', '.open-modal', function (e) {
    e.preventDefault();
    var button = $(this);
    var modalname = $(this).attr('href');
    var nameCard = $(this).attr('data-name');
    var tipoCard = $(this).attr('data-tipo');
    $('.nameCard').html(nameCard);
    $('.inputNameCard').val(tipoCard);

    if ($('.' + modalname).attr('data-width') != '') {
        $('.' + modalname + '>.modal-dialog').css('width', $('.' + modalname).attr('data-width') + 'px');
        //console.log($('.' + modalname + ' .modal-dialog'), $('.' + modalname).attr('data-width'));
    }
    $('html, body').addClass('modal-open');
    $('<div class="modal-backdrop"></div>').appendTo("body").fadeTo(300, 0.85);
    $('.' + modalname).fadeTo(150, 1);
});

// fecha modal
$(document).on('click', '.modal .close, .modal-backdrop', function (e) {
    e.preventDefault();
    $('html, body').removeClass('modal-open');
    $('.modal-backdrop').fadeTo(300, 0, function () {
        $('.modal-backdrop').remove();
    });
    $('.modal').fadeTo(150, 0, function () {
        $('.modal').removeAttr('style');
    });
});

$('.c-tab-caminho__head').on('click', function (e) {
    //e.preventDefault();
    $('.c-tab-caminho__head').removeClass('is-active');
    $(this).addClass('is-active');
    var tipo = $(this).attr('data-tipo');
    $('.c-tab-caminho__content').addClass('d-none');
    $('.c-tab-linha__head').removeClass('is-active');
    $('.c-tab-linha__content').addClass('d-none');
    $('#' + tipo).removeClass('d-none');
});

$('.c-tab-linha__head').on('click', function (e) {
    e.preventDefault();
    if ($(this).hasClass('is-active')) {
        $(this).removeClass('is-active');
        $(this).parent().children('.c-tab-linha__content').addClass('d-none');
    } else {
        $('.c-tab-linha__head').removeClass('is-active');
        $('.c-tab-linha__content').addClass('d-none');
        $(this).addClass('is-active');
        $(this).parent().children('.c-tab-linha__content').removeClass('d-none');
    }
});

$(window).resize(function () {
    var width = $(window).width();
    if (width <= 625) {
        $("input").keyup(function () {
            if ($('#formId_partida').val() && ($('#formId_destino').val())) {
                $('.li-hora').show();
                console.log('oi');
            } else {
                $('.li-hora').hide();
            }
        });
    }
});

$('.js-scrollMenu').on('click', function (e) {
    e.preventDefault();
    var finalDestiny = $(this).attr('href');
    goToSection__scroll(finalDestiny, 125, 125, 700);
});

$('.js-scrollHorarios').on('click', function (e) {
    e.preventDefault();
    var finalDestiny = $(this).attr('href');
    var width = $(window).width();
    if (width <= 780) {
        goToSection__scroll(finalDestiny, 95, 95, 500);
    } else {
        goToSection__scroll(finalDestiny, 115, 115, 500);
    }
});

swiperHorario = new Swiper('.swiperHorario', {
    slidesPerView: 1,
    spaceBetween: 0,
    allowSlideNext: false, //bloqueia proximo slide
    allowSlidePrev: false, //bloqueia slide anterior
    breakpoints: {
        // when window width is >= 320px
        841: {
            slidesPerView: 3,
            allowSlideNext: true,
            allowSlidePrev: true,
            spaceBetween: 15,
        },
        715: {
            slidesPerView: 2,
            allowSlideNext: true,
            allowSlidePrev: true,
            spaceBetween: 10,
        },
        516: {
            allowSlideNext: true,
            allowSlidePrev: true,
            slidesPerView: 1,
            spaceBetween: 0
        }
    },
    navigation: {
        nextEl: '.s-horarios__arrows.swiper-button-next',
        prevEl: '.s-horarios__arrows.swiper-button-prev',
    },
});

swiperHorario.on('slideChangeTransitionEnd', function () {
    var SlideAtivo = $('.swiperHorario .swiper-slide-active').children('.c-tab-caminho__head');
    var tipo = SlideAtivo.attr('data-tipo');
    var ativos = $('.swiperHorario .c-tab-caminho__head.is-active').length;
    if (ativos > 0) {
        $('.swiperHorario .c-tab-caminho__head').removeClass('is-active');
        $('.swiperHorario .c-tab-caminho__head[data-tipo="' + tipo + '"]').addClass('is-active');
        $('#intermunicipais .c-tab-caminho__content').addClass('d-none');
        $('#intermunicipais .c-tab-linha__head').removeClass('is-active');
        $('#intermunicipais .c-tab-linha__content').addClass('d-none');
        $('#' + tipo).removeClass('d-none');
    }
});

swiperHorarioMun = new Swiper('.swiperHorarioMun', {
    slidesPerView: 1,
    spaceBetween: 0,
    allowSlideNext: false, //bloqueia proximo slide
    allowSlidePrev: false, //bloqueia slide anterior
    breakpoints: {
        // when window width is >= 320px
        841: {
            slidesPerView: 3,
            allowSlideNext: true,
            allowSlidePrev: true,
            spaceBetween: 15,
        },
        715: {
            slidesPerView: 2,
            allowSlideNext: true,
            allowSlidePrev: true,
            spaceBetween: 10,
        },
        516: {
            allowSlideNext: true,
            allowSlidePrev: true,
            slidesPerView: 1,
            spaceBetween: 0
        }
    },
    navigation: {
        nextEl: '.s-horariosMun__arrows.swiper-button-next',
        prevEl: '.s-horariosMun__arrows.swiper-button-prev',
    },
});

swiperHorarioMun.on('slideChangeTransitionEnd', function () {
    var SlideAtivo = $('.swiperHorarioMun .swiper-slide-active').children('.c-tab-caminho__head');
    var tipo = SlideAtivo.attr('data-tipo');
    var ativos = $('.swiperHorarioMun .c-tab-caminho__head.is-active').length;

    console.log(ativos + ' ## ' + tipo);
    if (ativos > 0) {
        $('.swiperHorarioMun .c-tab-caminho__head').removeClass('is-active');
        $('.swiperHorarioMun .c-tab-caminho__head[data-tipo="' + tipo + '"]').addClass('is-active');
        $('#municipais .c-tab-caminho__content').addClass('d-none');
        $('#municipais .c-tab-linha__head').removeClass('is-active');
        $('#municipais .c-tab-linha__content').addClass('d-none');
        $('#' + tipo).removeClass('d-none');
    }
});


$(".simpleSelect2").select2({
    language: "pt-BR"
});

$(".ajaxSelect2").select2({
    language: "pt-BR",
    ajax: {
        dataType: 'json'
    },
    minimumInputLength: 1
});

$('.timepicker').wickedpicker({
    twentyFour: true,
    title: 'Selecione o horário'
});

var selectDestino = $("#formId_destino").select2({
    language: "pt-BR",
    placeholder: "Aguardando local de partida"
});

$('body').on('change', '#formId_partida', function () {
    var partida = $(this).val();
    $.ajax({
        type: "POST",
        data: {partida: partida},
        url: "select-destino",
        success: function (result) {
            $('#formId_destino').html(result);
            selectDestino.select2('destroy');
            selectDestino.val(null).trigger("change");
            selectDestino.select2({
                language: "pt-BR",
                placeholder: "Selecione o destino"
            });
        }
    });
});

var selectDestino2 = $("#formId_destino2").select2({
    language: "pt-BR",
    placeholder: "Aguardando local de partida"
});

$('body').on('change', '#formId_partida2', function () {
    var partida = $(this).val();
    $.ajax({
        type: "POST",
        data: {partida: partida},
        url: "select-destino",
        success: function (result) {
            $('#formId_destino2').html(result);
            selectDestino2.select2('destroy');
            selectDestino2.val(null).trigger("change");
            selectDestino2.select2({
                language: "pt-BR",
                placeholder: "Selecione o destino"
            });
        }
    });
});

$('#formHorario').validate({
    submitHandler: function (form) {
        //SUBMIT form
        $(form).ajaxSubmit({
            beforeSubmit: function () {
                $('.tempoRealResult').removeClass('d-none');
                $('.tempoRealResult .resultContent').html('<li> Buscando horários...</li>');
                $('#formHorario .btnSearchHours').attr('disabled', true);
            },
            success: function (result) {
                console.log(result);
                $('.tempoRealResult .resultContent').html(result);
                $('#formHorario .btnSearchHours').attr('disabled', false);
            }
        });
    }
});

$('#formHorario2').validate({
    submitHandler: function (form) {
        //SUBMIT form
        $(form).ajaxSubmit({
            beforeSubmit: function () {
                $('.tempoRealResult2').removeClass('d-none');
                $('.tempoRealResult2 .resultContent2').html('<li> Buscando horários...</li>');
                $('#formHorario2 .btnSearchHours').attr('disabled', true);
            },
            success: function (result) {
                console.log(result);
                $('.tempoRealResult2 .resultContent2').html(result);
                $('#formHorario2 .btnSearchHours').attr('disabled', false);
            }
        });
    }
});

function anchorHashLinhas() {
    var hash = location.hash;
    var elem = $(hash);
    var idTab = elem.parent().parent('.c-tab-caminho__content').attr('id');
    var target = '#' + elem.parent().children('.c-tab-linha__head').attr('id');

    $('[data-tipo="' + idTab + '"]').addClass('is-active');

    elem.removeClass('d-none');
    elem.parent().parent('.c-tab-caminho__content').removeClass('d-none');
    elem.parent().children('.c-tab-linha__head').addClass('is-active');
    if (hash !== '' && hash !== null && hash !== undefined) {
        var width = $(window).width();
        if (width <= 780) {
            goToSection__scroll(target, 95, 95, 500);
        } else {
            goToSection__scroll(target, 115, 115, 500);
        }
    }
}

$('body').on('click', '.btnSearchLines', function (e) {
    e.preventDefault();
    if ($('#formLinha').valid()) {
        $('#formLinha .btnSearchLines').attr('disabled', true).children('strong').html('Aguarde ...');
        var link = $('#formId_linha').val();
        window.location.href = 'horarios#' + link;
        if ($('#page__horarios').length) {
            //anchorHashLinhas();
            location.reload();
        }
    }
})

$('body').on('click', '.btnSearchLines2', function (e) {
    e.preventDefault();
    if ($('#formLinha2').valid()) {
        $('#formLinha2 .btnSearchLines2').attr('disabled', true).children('strong').html('Aguarde ...');
        var link = $('#formId_linha2').val();
        window.location.href = 'horarios#' + link;
        if ($('#page__horarios').length) {
            //anchorHashLinhas();
            location.reload();
        }
    }
})

$('body').on('click', '.btnGoLines', function (e) {
    e.preventDefault();
    var link = $(this).attr('href');
    window.location.href = link;
    if ($('#page__horarios').length) {
        //anchorHashLinhas();
        location.reload();
    }
})

if ($('#page__horarios').length) {
    anchorHashLinhas();
}

function _indiceH6(sulfix) {
    var i = 1;
    $('.t_Funcionario' + sulfix).each(function () {
        $(this).html('Funcionario ' + i);
        i++;
    });
}

// Cadastro de PJ
$(document).ready(function () {
    var indexFuncionario = 2;
    var attrName = 2;
    $('body').on('click', '#formCadastro .addNewForm_funcionarios', function (event) {
        $.ajax({
            type: "POST",
            url: "components/form_cadastro_pj_AJAX.php",
            data: {
                indexPJ: indexFuncionario,
                attrName: attrName
            },
            success: function (result) {
                $('#formCadastro .list_funcionarios_field').append(result);
                _indiceH6('PJ');
                indexFuncionario++;
                attrName++;
            }
        });
    });

    $('body').on('click', '#formCadastro .trashOL', function () {
        $(this).parent().parent('.funcionarioPF_style').remove();
        _indiceH6('PJ');
    });
})


if ($('.formHorario').length) {
    $('a.horarioForquilhinha').on('click', function (e) {
        e.preventDefault();
        $('a.horarioForquilhinha').toggleClass('is-active');
        $('.boxForm.horarioForquilhinha').toggleClass('d-none');
        if ($('a.horarioForquilhinha').hasClass('is-active')) {
            $('a.horarioIntermunicipal').removeClass('is-active');
            $('.boxForm.horarioIntermunicipal').addClass('d-none');
        }
    })
    $('a.horarioIntermunicipal').on('click', function (e) {
        e.preventDefault();
        $('a.horarioIntermunicipal').toggleClass('is-active');
        $('.boxForm.horarioIntermunicipal').toggleClass('d-none');
        if ($('a.horarioIntermunicipal').hasClass('is-active')) {
            $('a.horarioForquilhinha').removeClass('is-active');
            $('.boxForm.horarioForquilhinha').addClass('d-none');
        }
    })
}
